<div class="flex flex-col h-full">
  <div class="p-4 md:p-6 space-y-4">
    <!-- Invoice Context Card -->
    <div class="bg-surface-high border border-border rounded-lg p-4 flex items-start gap-3">
      <lucide-icon name="send" class="w-5 h-5 text-primary mt-0.5 shrink-0"></lucide-icon>
      <div class="min-w-0">
        <app-text weight="medium" class="text-foreground block truncate">
          Invoice #{{ invoice?.invoiceNumber }}
        </app-text>
        <app-text variant="muted" size="xs" class="block mt-0.5">
          {{ invoice?.invoicingMethod === 'factoring' ? 'Factoring Submission' : 'Direct Billing' }}
          &middot; {{ invoice?.loadIds?.length || 0 }} load{{ invoice?.loadIds?.length === 1 ? '' : 's' }}
          &middot; {{ invoice?.totalAmount | currency }}
        </app-text>
      </div>
    </div>

    <!-- Recipient Info Form -->
    <div class="space-y-4">
      <app-form-field
        label="Recipient Name"
        hint="Name of the factoring company, broker, or customer"
      >
        <app-input
          type="text"
          placeholder="e.g. Apex Factoring or C.H. Robinson"
          prefixIcon="Building2"
          [ngModel]="recipientName()"
          (ngModelChange)="recipientName.set($event)"
        ></app-input>
      </app-form-field>

      <app-form-field
        label="Recipient Email(s)"
        hint="Separate multiple email addresses with commas (e.g. billing@company.com, ap@company.com)"
      >
        <app-input
          type="text"
          placeholder="billing@company.com, ap@company.com"
          prefixIcon="Mail"
          [ngModel]="recipientEmails()"
          (ngModelChange)="recipientEmails.set($event)"
        ></app-input>
      </app-form-field>
    </div>

    <!-- Resend Details Info Note -->
    <div class="p-3 bg-surface rounded-lg border border-border text-xs text-muted space-y-1">
      <div class="flex items-center gap-1.5 font-medium text-foreground">
        <lucide-icon name="info" class="w-4 h-4 text-primary shrink-0"></lucide-icon>
        <span>Package Contents</span>
      </div>
      <p class="leading-relaxed">
        Resending will generate and attach the latest Invoice Summary Sheet PDF reflecting all approved rates, detention, and TONU fees, along with all rate confirmations and PODs.
      </p>
    </div>
  </div>

  <!-- Modal Actions -->
  <div class="mt-auto p-4 md:p-6 pt-3 flex justify-end gap-3 border-t border-border bg-surface">
    <app-button variant="ghost" (click)="close()" [disabled]="isSending()">
      Cancel
    </app-button>
    <app-button
      variant="primary"
      icon="send"
      (click)="send()"
      [loading]="isSending()"
      [disabled]="isSending()"
    >
      Resend Invoice
    </app-button>
  </div>
</div>
